import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, switchMap, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import {
    TokenValidationResponse,
    TokenValidationService,
} from '../services/token-validation/token-validation.service';
import { ErrorService } from '../services/generic-error/error.service';
import utils from '../utils/account-permission/account-permission.util';
import { withCatchErrorSideEffects } from '../utils/rxjs-operators/with-catch-error-side-effects';
import { LoggerService } from '../services/logger/logger.service';
import { ZciCookieService } from '../services/zci-cookie/zci-cookie.service';

@Injectable({
    providedIn: 'root',
})
export class TokenValidationPublicResolver implements Resolve<TokenValidationResponse> {
    private store = inject(Store);
    private tokenValidationService = inject(TokenValidationService);
    private errorService = inject(ErrorService);
    private loggerService = inject(LoggerService);
    private cookieService = inject(ZciCookieService);


    resolve(route: ActivatedRouteSnapshot): Observable<TokenValidationResponse> {
        const token = this.getTokenFromRoute(route);
        return this.cookieService.clearLogonCookiesPublic().pipe(
            switchMap(() => this.tokenValidationService.tokenValidationPublic(token)),
            tap((data: TokenValidationResponse) => {
                utils.handleAccessTypeAndClientTypeUpdate(data, this.store, this.errorService, true);
            }),
            withCatchErrorSideEffects(this.errorService, this.loggerService),
        );
    }

    private getTokenFromRoute(route: ActivatedRouteSnapshot): string {
        return route.queryParams['token'] ?? route.params.token;
    }
}
